import React from "react";
import { getTranslation } from "../TranslationWrapper/TranslationWrapper";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import { MenuItem, Select } from "@mui/material";
import { withStyles } from "tss-react/mui";
import productenStyle from "../../assets/jss/material-dashboard-pro-react/views/productStyle";

function BetaaldStatusFilter(props) {
  const { classes } = props;

  let value = "ALL";
  if (props["is_betaald"]?.value === 0) {
    value = "0";
  } else if (props["is_betaald"]?.value === 1) {
    value = "1";
  }

  const status = [
    {
      value: "ALL",
      label: getTranslation("bestellingen.filers.is_betaald.all", "Betaalde en niet betaalde orders"),
    },
    {
      value: "0",
      label: getTranslation("bestellingen.filers.is_betaald.nonpaid", "Alleen niet betaalde orders"),
    },
    {
      value: "1",
      label: getTranslation("bestellingen.filers.is_betaald.paid", "Alleen betaalde orders"),
    },
  ];

  return (
    <Select
      MenuProps={{
        className: classes.selectMenu,
      }}
      classes={{
        select: classes.select,
      }}
      inputProps={{
        name: "simpleSelect",
        id: "simple-select",
        style: { paddingTop: "32px" },
      }}
      onChange={(e) => {
        let selectedStatusOrder = e.target.value;

        switch (selectedStatusOrder) {
          case "ALL":
            props.setFilter("is_betaald", null);
            break;
          case "0":
            props.setFilter("is_betaald", { field: "is_betaald", operator: "=", value: 0 });
            break;
          case "1":
            props.setFilter("is_betaald", { field: "is_betaald", operator: "=", value: 1 });
            break;
        }
      }}
      value={value}
    >
      {status.map((item) => (
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          key={item.value}
          value={item.value}
        >
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
}

const mapStateToProps = (state) => ({
  ["is_betaald"]: state.filtersV2["is_betaald"],
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, filter) => {
    dispatch({
      type: actions.SET_FILTER,
      payload: { key, filter },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(BetaaldStatusFilter, productenStyle));
